import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Title, ContentContainer, Button } from 'Helpers/GlobalStyles';

const SignIn = () => {
  const history = useHistory();

  const openLoginModal = () => {
    window.location.hash = '';
    window.location.hash = 'login';
    history.push({
      search: '?openAccountModal=signIn&returnUrl=%2Fpayments%2Fmake-payment',
    });
  };

  useEffect(() => openLoginModal(), []);

  return (
    <ContentContainer>
      <Title>Please Sign In To Continue</Title>
      <Button onClick={openLoginModal}>Sign In</Button>
    </ContentContainer>
  );
};

export default SignIn;
